module.exports = __webpack_public_path__ + "img/32.564556ec.png";